module.exports = __webpack_public_path__ + "img/MATERIAL1.01553458.png";